import { render, staticRenderFns } from "./group.vue?vue&type=template&id=70eea693&scoped=true"
import script from "./group.vue?vue&type=script&lang=ts"
export * from "./group.vue?vue&type=script&lang=ts"
import style0 from "./group.vue?vue&type=style&index=0&id=70eea693&prod&lang=scss&scoped=true"
import style1 from "./group.vue?vue&type=style&index=1&id=70eea693&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eea693",
  null
  
)

export default component.exports